const SearchIcon = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2615 14.0747L17.3524 18.1656C17.5765 18.3897 17.9409 18.3897 18.1651 18.1656C18.3892 17.9414 18.3892 17.577 18.1651 17.3529L14.0742 13.262C15.1173 12.0338 15.7472 10.4436 15.7472 8.70734C15.7472 4.82164 12.5926 1.66699 8.70686 1.66699C4.82116 1.66699 1.6665 4.82164 1.6665 8.70734C1.6665 12.593 4.82116 15.7477 8.70686 15.7477C10.4431 15.7477 12.0333 15.1178 13.2615 14.0747ZM8.70686 2.81644C11.9581 2.81644 14.5978 5.45614 14.5978 8.70734C14.5978 11.9585 11.9581 14.5983 8.70686 14.5983C5.45565 14.5983 2.81595 11.9585 2.81595 8.70734C2.81595 5.45614 5.45565 2.81644 8.70686 2.81644Z"
          fill="black"
        />
      </svg>
  );
};
export default SearchIcon;
